import script from "./DynamicConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./DynamicConfirmationModal.vue?vue&type=style&index=0&id=6a498039&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a498039"]])

export default __exports__